import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CTAButtonVariant } from '@/shared/enums';
import { NgClass } from '@angular/common';

@Component({
  selector: 'bevvi-cta-button',
  imports: [NgClass],
  templateUrl: './cta-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtaButton {
  public readonly label = input.required<string>();
  public readonly variant = input<CTAButtonVariant>(CTAButtonVariant.FILLED);
  public readonly disabled = input(false);

  public readonly buttonClick = output<void>();

  protected readonly buttonClasses = computed(() => ({
    'bg-solid-teal-500 text-solid-white-500': this.variant() === CTAButtonVariant.FILLED,
    'border border-solid-gray-500 text-solid-teal-500 bg-transparent':
      this.variant() === CTAButtonVariant.OUTLINE,
    'opacity-50 cursor-not-allowed': this.disabled(),
  }));

  protected readonly bgColor = computed(() =>
    this.variant() === CTAButtonVariant.FILLED
      ? 'var(--bot-primary, #004251)'
      : 'transparent',
  );

  protected readonly textColor = computed(() =>
    this.variant() === CTAButtonVariant.FILLED
      ? 'var(--bot-btn-content, #fff)'
      : 'var(--bot-primary, #004251)',
  );

  protected readonly borderColor = computed(() =>
    this.variant() === CTAButtonVariant.OUTLINE
      ? 'var(--bot-primary, #004251)'
      : 'transparent',
  );
}
